/** Shared signup gate token — keep in sync with frontend signup-access. */
export const SIGNUP_ACCESS_HEADER = 'x-signup-access';
export const SIGNUP_ACCESS_TOKEN = 'cb-bh-signup-gate-7x-login';
